/// <reference path="../_references.js" />

var mZonesControls = new ZonesControls(),
    mZonesData = new ZonesData();

function resetContentHoldersZones() {
    "use strict";
    if (!gUserDetails.RegionalOri) {
        $("#uZonesTab").removeClass("regionalOri");
    }
    var lWindowWidth = $(window).width(),
        lWindowHeight = $(window).height(),
        lMapContentHeight = $('#uZonesMapHolder').height(),
        lMapPlaybackHeight = $('#uMapPlaybackPanel').height(),
        lMapHolderHeight = lMapContentHeight - (lMapPlaybackHeight + 10), //640
        lMapWidth = $('#uMapPanel').width(),
        lMapHeight = $('#uMapPanel').height(),
        lMapOffset = $('#uMapPanel').offset(),
        lNotificationWidth = $('#uMapNotificationPanel').width(),
        lLocateRight,
        lLocateBottom;

    if (!isNullOrUndefined(lMapOffset)) {
        lLocateRight = lWindowWidth - (lMapWidth + lMapOffset.left);
        lLocateBottom = lWindowHeight - (lMapHeight + lMapOffset.top);
        if (lLocateRight > 180 && lLocateBottom > 0) {
            $('#uMapNotificationPanel').css('bottom', (lLocateBottom).toString() + 'px');
        }
        $('#uMapNotificationPanel').css('margin-left', ((lMapWidth - lNotificationWidth) / 2).toString() + 'px');
    }

    setHeight('#uMapPanel', lMapHolderHeight);
    setHeight('#uMapLegendPanel', lMapHolderHeight + lMapPlaybackHeight);
}

//-----------------------
// State Manager Handlers
//-----------------------
function mStateManagerZones_Init(aPrevious, aCurrent) {
    "use strict";
    var lLayout = aCurrent.Tab + '.Layout.htm';
    if (applyUserPermissionsNavigation(gPageClassManager.System, aCurrent.Tab)) {
        mZonesControls.CardViewTimer = new TimerManager(500);
        zonesDataListConverter();
        mCache.bind('Zonesupdated', zonesDataItem_Updated, null);
        populateElement('uMasterContentHolder', lLayout, ZonesTabContent_OnComplete);
    }
}

function mStateManagerZonesLayout_Init(aPrevious, aCurrent) {
    "use strict";
    populateElement('uZonesMainContentPanel', 'Zones.Map.Layout.htm', mStateManagerZonesLayout_OnLoad);
}

function mStateManagerZonesPrimary_Init(aPrevious, aCurrent) {
    "use strict";
    var lNavigatedFromAddressZoneEdit = getViewState('NavigatedFromAddressZoneEdit'),
        lReturnEnrolleeId = getViewState('ZoneReturnEnrolleeId'),
        lZone;
    if (!isNullOrUndefined(mStateManager.Settings()[1]) && mStateManager.Settings()[1] !== 'null') {
        mZonesData.TargetId = parseInt(mStateManager.Settings()[1]);
        lZone = getDataItem(mZonesData.TargetId, 'Zones');
        mStateManager.ChangeSettings(1, null);
        mZonesControls.CardViewFilter.filter();
    }    
    uZonesCardViewSortOnViewState();
    if (!isNullOrUndefined(lNavigatedFromAddressZoneEdit) && lZone) {
        if (lNavigatedFromAddressZoneEdit.Value === true) {
            $('#uEnrolleeAddressBackButton').show();
            if (hasProduct(lReturnEnrolleeId.Value, 103) || hasProduct(lReturnEnrolleeId.Value, 151) || isNullOrUndefined(gCurrentDeviceAssignment[lReturnEnrolleeId.Value]) || gCurrentDeviceAssignment[lReturnEnrolleeId.Value].length === 0) {
                if (lZone.Type == 1) {
                    $('#uEnrolleeScheduleBackButton').show();
                } else {
                    $('#uEnrolleeScheduleBackButton').hide();
                }
            } else {
                $('#uEnrolleeScheduleBackButton').hide();
            }
        } else {
            $('#uEnrolleeAddressBackButton').hide();
            $('#uEnrolleeScheduleBackButton').hide();
        }
    }
    // localize here
    veritracks.localization.localizeTitle();   
}

//--------------
// Load Complete
//--------------
function ZonesTabContent_OnComplete() {
    "use strict";
    applyUserPermissions([2]);
    $('#uMasterMenuPanel').show();
    mStateManagerZonesLayout_Init();
    //added for page refresh
    if (gUserDetails.RegionalOri && (getViewState("isRegionalLoaded") == null || getViewState("isRegionalLoaded") == false)) {
        uMasterMenuPanel_OnClick($('#uZonesTab'), 'Enrollees.Offenders.Profile.Events');
    }
}

function mStateManagerZonesLayout_OnLoad() {
    "use strict";
    populateElement('uMapLegendContent', 'Map.Legend.htm', null);
    //populateElement('uMapLocateContent', 'Map.Locate.htm', null);
    populateElement('uMapDetailsContent', 'Zones.Map.Details.htm', zonesMapDetails_OnLoad);
}

function zonesMapDetails_OnLoad() {
    "use strict";
    var lPermission = gUserPermissions[35];
    applyUserPermissions([2, 35]);

    mZonesControls.NotificationPanel = new SumoActivityNotification('uMapNotificationPanel', 'uZonesMapPanel', 50, { 'allowClose': true });
    mZonesControls.NotificationPanel.render();
    zonesMap_Init();
    zonesCardView_Init();
    zonesMapDropdowns_Init();
    resetContentHolders();
    $(window).resize();
    if (!isNullOrUndefined(lPermission) && lPermission.Value ===0) {
        $('#uZonesDetailScopeNonEdit').removeClass('Hidden');
    }
    $('#uClassifiedZone').hide();
    mStateManagerZonesPrimary_Init();
    updateMeasurementUnit(".cZonesMeasurement");
}

//------
// Leave
//------
function mStateManagerZones_Leave(aPrevious, aCurrent) {
    "use strict";

    mCache.unbind('Zonesupdated', zonesDataItem_Updated);

    if (!isNullOrUndefined(mZonesControls.CardView)) {
        mZonesControls.CardView.unbind('selectedchanged', mZonesCardView_OnSelectedChange);
        mZonesControls.CardView.unbind('databind', cardView_OnDataBind);
        mZonesControls.CardView.dispose();
        mZonesControls.CardView = null;
    }
    if (!isNullOrUndefined(mZonesControls.CardViewFilter)) {
        mZonesControls.CardViewFilter.dispose();
        mZonesControls.CardViewFilter = null;
    }
    if (!isNullOrUndefined(mZonesControls.CardViewPaginator)) {
        mZonesControls.CardViewPaginator.unbind('pagechanged', uZonesPaginator_OnPageChanged);
        mZonesControls.CardViewPaginator.dispose();
        mZonesControls.CardViewPaginator = null;
    }

    if (!isNullOrUndefined(mZonesControls.Map)) {
        mZonesControls.Map.dispose();
        mZonesControls.Map = null;
    }
    if (!isNullOrUndefined(mZonesControls.MapLocate)) {
        mZonesControls.MapLocate.bind('complete', zonesPlaces_OnComplete);
        mZonesControls.MapLocate.dispose();
        mZonesControls.MapLocate = null;
    }
    if (!isNullOrUndefined(mZonesControls.DetailsDropdown)) {
        mZonesControls.DetailsDropdown.dispose();
        mZonesControls.DetailsDropdown = null;
    }
    if (!isNullOrUndefined(mZonesControls.LocateDropdown)) {
        mZonesControls.LocateDropdown.dispose();
        mZonesControls.LocateDropdown = null;
    }
    if (!isNullOrUndefined(mZonesControls.Validator)) {
        mZonesControls.Validator.dispose();
        mZonesControls.Validator = null;
    }
    if (!isNullOrUndefined(mZonesControls.NotificationPanel)) {
        mZonesControls.NotificationPanel.dispose();
        mZonesControls.NotificationPanel = null;
    }

    if (!isNullOrUndefined(mZonesControls.CardViewTimer)) {
        mZonesControls.CardViewTimer = null;
    }

    setViewState('NavigatedFromAddressZoneEdit', false);
    setViewState('ZoneReturnEnrolleeId', null);

    mZonesData.Clean = null;
    mZonesData.Dirty = null;
    mZonesData.Paginated = null;
    mZonesData.CurrentId = -1;
    mStateManagerZonesLayout_Leave(aPrevious, aCurrent);
}

function mStateManagerZonesLayout_Leave(aPrevious, aCurrent) {
    "use strict";

}

//----------------
// List Population
//----------------
function zonesDataListConverter() {
    "use strict";
    var lZones = getDataItems('Zones'),
        lAgents = getDataItems('Agents'),
        lOrganizations = getDataItems('Organizations'),
        lZoneCards = [],
        lCard,
        lMyAgentIds,
        lZone,
        lAgent,
        lOrganization,
        lKey,
        lSortState = getViewState('ZonesCardViewSort'),
        lBuilder = new SumoPredicateBuilder();

    lMyAgentIds = getMyAgentIds(gUserDetails.UserId);
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('Id', 0, false, mRelationalOperatorEnum.GreaterThan(), mLogicalOperatorEnum.And());
    lZones = query(lZones, lBuilder.RootExpression);
    for (lKey in lZones) {
        if (lZones.hasOwnProperty(lKey)) {
            lZone = lZones[lKey];
            lAgent = lAgents[lZone.AgentId];
            lOrganization = lOrganizations[lZone.OrganizationId];
            lCard = new ZoneCardView(lZone, lAgent, lOrganization);
            lCard.IsMine = (lMyAgentIds.indexOf(lZone.AgentId)!== -1);
            lZoneCards[lZone.Id] = lCard; 
        }
    }

    mZonesData.Clean = lZoneCards;
    mZonesData.Dirty = null;
    mZonesData.Paginated = null;
    mZonesData.Sort = null;
    if (!isNullOrUndefined(lSortState)) {
        mZonesData.Sort = lSortState.Value.sort(mZonesData.Clean);
    }

}

function zonesDataItem_Updated(aCache, aData) {
    "use strict";
    var lCache = aCache,
        lData = aData;
   
    if (!isNullOrUndefined(mZonesControls.CardView)) {
        if (UpdateViewOnNewData(lData, mZonesData.Paginated)) {
            zonesDataListConverter();
            mZonesControls.CardView.setUpdated(true);
        }
    }
}

function uZonesCardViewFilterOrganization_OnChange(aSender, aData, aParams) {
    "use strict";
    var lOrganizationIds = aData.currentTarget.value,
        lBuilder = new SumoPredicateBuilder(),
        lZoneClassificationsIds = [],
        lZoneClassifications = [];

    function aZoneClassificationSuccess(aParams, aData) {

        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                if (lZoneClassificationsIds.indexOf(aData[key].ZoneClassificationId) == -1) {
                    lZoneClassifications.push(aData[key]);
                    lZoneClassificationsIds.push(aData[key].ZoneClassificationId)
                }
            }
        }

        if (!isNullOrUndefined(aData)) {
            lZoneClassifications.push({ Id: -1, ZoneClassificationId: -1, ZoneClassificationName: "Unclassified" });
            mZonesControls.CardViewFilter.setColumnDataSource('ZoneClassificationId', lZoneClassifications);
        }

    }
        
     lBuilder.AddNewExpressionConditional('OrganizationId', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
     ReadMultiple(gObjectList.OriZoneClassification.AssemblyQualifiedName, lBuilder.RootExpression, 0, aZoneClassificationSuccess, null, {}, null, 0, false);
  
}

function formatUserDetails() {

    var lUsers = getDataItems('Users'),
         lItem,
         lUserDetails = {},
         lUserList = [],
         lKey,
         lOrganization = 11,
         lBuilder = new SumoPredicateBuilder();

    for (lKey in lUsers) {
        if (lUsers.hasOwnProperty(lKey)) {
            lItem = lUsers[lKey];
            lItem.AgentIds = getMyAgentIds(lItem.Id);
            lUserList.push(lItem);
        }
    }
    return lUserList;
}

function gFilterFactory_OnZonesInit(aSender, aEvent, aData) {
    "use strict";
    var lUserPreferences = getUserPreferences(7),
        lOrganizations,
        lBuilder = new SumoPredicateBuilder();
        

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);
     
    mZonesControls.CardViewFilter = aSender.createControl(
    'uZonesCardViewFilter',
    'uZonesListFilterHolder',
    {
        'Title': localizeWrapper('cZoneFindZones'),
        'Content': '',
        'CssClass': 'DefaultFilter',
        'HideOnFilter': true,
        'OnFilter': uZonesCardViewFilter_OnFilter,
        'Columns': [
                { 'Id': 'Name', 'Title': localizeWrapper('cEnrolleeName'), 'Type': 'Text', 'DataField': 'Name' },
                { 'Id': 'Description', 'Title': localizeWrapper('cEnrolleeDescription'), 'Type': 'Text', 'DataField': 'Description' },
                { 'Id': 'OrganizationId', 'Title': localizeWrapper('cEnrolleeOrganization'), 'Type': 'Dropdown', 'DataField': 'OrganizationId', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name', 'DefaultValue': '', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'AgentName', 'Title': localizeWrapper('cAgent'), 'Type': 'Text', 'DataField': 'AgentName' },
                { 'Id': 'Type', 'Title': localizeWrapper('cZoneType'), 'Type': 'Dropdown', 'DataField': 'Type', 'DataSource': getDataItems('ZoneType'), 'LocaleName': 'ZoneType', 'DataValueField': 'Id', 'DataTextField': 'Description', 'ComparisonType': null, 'InsertBlank': true, 'DefaultValue': '', 'BlankText': localizeText('cAll') },
                { 'Id': 'Shape', 'Title': localizeWrapper('cZoneShape'), 'Type': 'Dropdown', 'DataField': 'Shape', 'DataSource': getDataItems('ZoneShape'), 'LocaleName': 'ZoneShape', 'DataValueField': 'Id', 'DataTextField': 'Description', 'ComparisonType': null, 'InsertBlank': true, 'BlankText': localizeText('cAll'), 'DefaultValue': '' },
                { 'Id': 'Scope', 'Title': localizeWrapper('cZoneScope'), 'Type': 'Dropdown', 'DataField': 'Scope', 'DataSource': [{ 'Id': 1, 'Description': localizeText('cZoneScopeRegular') }, { 'Id': 3, 'Description': localizeText('cZoneScopeGlobal') }], 'DataValueField': 'Id', 'DataTextField': 'Description', 'ComparisonType': null, 'InsertBlank': true, 'DefaultValue': '', 'BlankText': localizeText('cAll') },
                { 'Id': 'IsAssigned', 'Title': localizeWrapper('cEnrolleeIsAssigned'), 'Type': 'Dropdown', 'DataField': 'IsAssigned', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
                { 'Id': 'IsMine', 'Title': localizeWrapper('cZoneIsMine'), 'Type': 'Dropdown', 'DataField': 'IsMine', 'DataSource': [{ 'Value': true, 'Text': localizeText('cYes') }, { 'Value': false, 'Text': localizeText('cNo') }], 'DataValueField': 'Value', 'DataTextField': 'Text', 'DefaultValue': '', 'ComparisonType': 'Boolean', 'InsertBlank': true, 'BlankText': localizeText('cBoth') },
                { 'Id': 'ZoneClassificationId', 'Title': localizeWrapper('cZoneClassification'), 'Type': 'Dropdown', 'DataField': 'ZoneClassificationId', 'DataSource': [], 'DataValueField': 'ZoneClassificationId', 'DataTextField': 'ZoneClassificationName', 'InsertBlank': true, 'BlankText': localizeText('cAll') },
        ],
        'Settings': null,
        'UserPreferences': lUserPreferences,
        'UserId': gUserDetails.UserId,
        'UserPreferenceType': 7,
        'LocalizableMethod': localizeDataItem
    });
    mZonesControls.CardViewFilter.bind('OrganizationIdchanged', uZonesCardViewFilterOrganization_OnChange);
    mZonesControls.CardViewFilter.init();
    mZonesControls.CardViewFilter.filter();
        
}

function gPaginatorFactory_OnZonesInit(aSender, aEventData, aData) {
    "use strict";
    var lZoneState = getViewState('ZonesSelectedZone'),
        lPageState = getViewState('ZonesSelectedPage');

    mZonesControls.CardViewPaginator = new sumo.controls.Paginator('uZonesPaginator', 'uZonesPagerHolder', {
        'ItemCount': count(mZonesData.Dirty),
        'ItemsPerPage': gPaginationSettings.ZonesItems
    });
    if (!isNullOrUndefined(lZoneState) && !isNullOrUndefined(lPageState)) {
        mZonesControls.CardViewPaginator.setPage(lPageState.Value);
    }
//    mZonesControls.CardViewPaginator = aSender.createControl('uZonesPaginator', 'uZonesPagerHolder', {
//        'ItemCount': count(mZonesData.Clean),
//        'ItemsPerPage': 500000
//    }
//    );
    mZonesControls.CardViewPaginator.bind('pagechanged', uZonesPaginator_OnPageChanged);
    //mZonesControls.CardViewPaginator.trigger('pagechanged');
    mZonesControls.CardViewFilter.filter();
}

function uZonesCardView_OnUpdate() {
    mZonesControls.CardViewFilter.filter();
    uZonesCardViewSortOnViewState();
}



function uZonesCardView_OnDataBind(aSender, aParams, aData) {
    "use strict";
    mZonesControls.CardView.unbind('databind', uZonesCardView_OnDataBind);
    mZonesControls.CardView.bind('databind', cardView_OnDataBind);
    mZonesControls.CardView.selected(aData);
}

function uZonesCardViewSortOnViewState() {
    "user strict";
    var lSortState = getViewState('ZonesCardViewSort');

    if (!isNullOrUndefined(lSortState)) {
        mZonesControls.CardView.sortExpression(lSortState.Value);
    }
}

function uZonesCardView_OnSort(aParams, aSort) {
    "use strict";
    var lZones = mZonesData.Clean,
        lZonesSortedList = [];

    lZonesSortedList = aSort.sort(lZones);
    mZonesData.Sort = lZonesSortedList;
    mZonesControls.CardViewFilter.filter();
    setViewState('ZonesCardViewSort', aSort);
}

function zonesCardView_Init() {
    "use strict";
    var lViewState = getViewState('ZonesSelectedZone');
    if (isNullOrUndefined(mZonesControls.CardView)) {       
        mZonesControls.CardView = new sumo.controls.CardView('uZonesCardView', 'uZonesListHolder', { 'cardTemplate': 'Interface/Zones.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': true, 'Columns': [{ 'id': 'Name', 'title': 'Name' }, { 'id': 'Description', 'title': 'Description' }, { 'id': 'OrganizationName', 'title': 'Organization Name' }, { 'id': 'AgentName', 'title': 'Agent Name' }, { 'id': 'Type', 'title': 'Type' }, { 'id': 'Scope', 'title': 'Scope' }] });
        mZonesControls.CardView.bind('selectedchanged', mZonesCardView_OnSelectedChange);
        mZonesControls.CardView.bind('sort', uZonesCardView_OnSort);
        if (!isNullOrUndefined(lViewState)) {
            mZonesControls.CardView.bind('databind', uZonesCardView_OnDataBind, lViewState.Value);
        } else {
            mZonesControls.CardView.bind('databind', cardView_OnDataBind);
        }
        mZonesControls.CardView.bind('update', uZonesCardView_OnUpdate);
    }
    if (isNullOrUndefined(mZonesControls.CardViewFilter)) {
        gFilterFactory_OnZonesInit(gFilterFactory, null, null);
    } else {
        mZonesControls.CardViewFilter.render();
    }    
}

function zonesMapShape_OnChange(aShape) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
    var lZoneRadius;
    if (mZonesData.EditItem.Shape === 1) {
        $('#uRadiusRow').show();
        mZonesData.EditItem.CenterLatitude = aShape.center.lat();
        mZonesData.EditItem.CenterLongitude = aShape.center.lng();
        
        if (lDoMetric) {
            lZoneRadius = aShape.radius;
        }
        else {
            lZoneRadius = convertMetersToFeet(aShape.radius);
        }

        $('#uZoneRadiusEdit').val(Math.round(lZoneRadius));
    } else {
        $('#uRadiusRow').hide();
        var lCenter = aShape.getCenter();
        mZonesData.EditItem.CenterLatitude = lCenter.lat();
        mZonesData.EditItem.CenterLongitude = lCenter.lng();
    }
}

function zonesMapRadius_OnClick() {
    "use strict";
    var lZoneRadiusInput = $('#uZoneRadiusEdit').val(),
    lShape = parseInt($('#uZonesDetailShapeEdit').val()),
    lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
    lCenter = mZonesControls.Map.getCenter(),
    lVertices = [],
    lType,
    lZone =  mZonesData.EditItem;
    lZone.Shape = lShape;
    if (lZoneRadiusInput==='') {
        $('#uZoneRadiusEdit').addClass('ValidateError');
    } else {
        $('#uZoneRadiusEdit').removeClass('ValidateError');
        if (lDoMetric) {
            lZone.Radius = parseFloat(convertMetersToFeet(lZoneRadiusInput));
        } else {
            lZone.Radius = parseFloat(lZoneRadiusInput);
        }
        lVertices.push({ 'latitude': lCenter.lat(), 'longitude': lCenter.lng() });
        lZone.vertices = lVertices;
        mZonesControls.Map.layerSetDataSource('Zones', veritracks.mapping.prepareZoneData([lZone]));
        mZonesData.EditShape = mZonesControls.Map.layerGetShape('Zones', lZone.Id);
        mZonesData.EditShape.setEditable(true);
        lType = parseInt($('#uZonesDetailTypeEdit').val());
        veritracks.mapping.changeColorOfShape(mZonesData.EditShape, lType);
        mZonesControls.Map.fitBounds();
    }
}

function zonesPlacesMarker_OnClick(aSender, aMouseEvent) {
    "use strict";
    veritracks.mapping.placesDetailGenerator(mZonesControls.NotificationPanel, aSender);
}

function ignoreme(aShape, event) {
    if (!aShape.editable) {
        mEnrolleesControls.OffenderTrackpointDetailCardView.selected('z' + aShape.sumoId.toString());
    }
}

function zonesMap_Init() {
    "use strict";
    var lSystemPreferences = getUserPreferences(10),
        lDisplayType = 'roadmap',
         lLayerOptions;

    if (!isNullOrUndefined(lSystemPreferences['MapDisplayType'])) {
        lDisplayType = lSystemPreferences['MapDisplayType'].Value;
    }
    //mZonesControls.Map = new sumo.maps.GoogleMapControl('uZoneMap', 'uMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': zonesCalculateDistance });
    mZonesControls.Map = new sumo.maps.GoogleMapControl('uZoneMap', 'uMapPanel', { 'displayType': lDisplayType, 'mapTypeId_OnChange': mapDisplayType_OnChange, 'OnClick': zonesCalculateDistance_OnClick });
    mZonesControls.Map.layerAdd('Zones', {
        'renderType': 'geometry',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1000000,
        'shapeChangeHandler': zonesMapShape_OnChange
    });

    mZonesControls.Map.layerAdd('TagLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1700000
    });

    mZonesControls.Map.layerAdd('ZonesNames', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000
    });

    lLayerOptions = {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': zonesPlacesMarker_OnClick,
        'zIndexStart': -10000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    };
    mZonesControls.Map.layerAdd('Places', lLayerOptions);

    mZonesControls.Map.layerAdd('DistancePoints', {
        'renderType': 'marker',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 1300000,
        'markerImageSize': { 'width': 32, 'height': 32 }
    });


    mZonesControls.Map.layerAdd('DistanceLabels', {
        'renderType': 'label',
        'doesPlayback': false,
        'isVisible': true,
        'clickEventHandler': null,
        'zIndexStart': 2000000
    });

    mZonesControls.Map.layerAdd('ConnectedDistancePoints', {
        'renderType': 'linesegment',
        'doesPlayback': true,
        'isVisible': true,
        'isClickable': false,
        'clickEventHandler': null,
        'zIndexStart': 700000
    });
    mZonesControls.MapLocate = new sumo.maps.Locate('uMapLocate', 'uMapLocateContent', mZonesControls.Map, {});
    mZonesControls.MapLocate.bind('complete', zonesPlaces_OnComplete);
}

function zonesMapDropdowns_Init() {
    "use strict";
    mZonesControls.DetailsDropdown = new sumo.controls.Dropdown('uDetailsDropdown', 'uDetailsHolder', {
        'title': localizeWrapper('cZoneZoneDetail'),
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': true,
        'cssClass': 'Events',
        'mSlideIntoView' : false,
        'content': $('#uMapDetailsContent')
    });

    mZonesControls.LocateDropdown = new sumo.controls.Dropdown('uLocateDropdown', 'uLocateHolder', {
        'title': localizeWrapper('cZoneLocate'),
        'viewportType': 'inline',
        'contentType': 'jQueryElement',
        'isOpen': true,
        'cssClass': 'Events',
        'mSlideIntoView': false,
        'content': $('#uMapLocateContent')
    });
    
      
}


//------------
// List Events
//------------
function uZoneEditDeleteButtons_SetVisibility() {
    "use strict";
    if ($('#uZonesListHolder').is(':visible')) {
        var lSelectedZone = mZonesControls.CardView.selectedDataItem(),
            lCanEdit = false,
            lOtherUserPermission = gUserPermissions[3],
            lGlobalZonePermission = gUserPermissions[35],
            lAgents = getDataItems('Agents'),
            lBuilder = new SumoPredicateBuilder(),
            lMyAgentIds = [],
            lItem,
            lKey;

        if (!isNullOrUndefined(lSelectedZone)) {
            lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lAgents = query(lAgents, lBuilder.RootExpression);

            for (lKey in lAgents) {
                if (lAgents.hasOwnProperty(lKey)) {
                    lItem = lAgents[lKey];
                    lMyAgentIds.push(lItem.Id);
                }
            }

            if (lMyAgentIds.indexOf(lSelectedZone.AgentId) !== -1) {
                lCanEdit = true;
            } else {
                if (!isNullOrUndefined(lOtherUserPermission)) {
                    lCanEdit = (lOtherUserPermission.Value === 2);
                }
            }

            if (lCanEdit && lSelectedZone.Scope === 3 && !isNullOrUndefined(lGlobalZonePermission)) {
                lCanEdit = (lGlobalZonePermission.Value === 1);
            }
            if (lCanEdit && lSelectedZone.PoiFlag != 1) {
                $('#uEditZoneButton').show();
            } else {
                $('#uEditZoneButton').hide();
            }

            if (lSelectedZone.EnrolleeCount > 0 || !lCanEdit) {
                $('#uDeleteZoneButton').hide();
            } else {
                $('#uDeleteZoneButton').show();
            }
            if(lSelectedZone.PoiFlag == 1){
                $('#uDeleteZoneButton').show();
            }
        }
    } else {
        $('#uDeleteZoneButton').hide();
        $('#uEditZoneButton').hide();
    }
}

function mZonesCardView_OnSelectedChange(aSender, aSelectedKey, aData) {
    "use strict";
    var lSelectedZone = mZonesControls.CardView.selectedDataItem(),
        lNavigatedFromAddressZoneEdit = getViewState('NavigatedFromAddressZoneEdit');

   
    veritracks.security.controller.extendSession();
    mZonesControls.NotificationPanel.clearNotifications();
    mZonesControls.Map.layerSetDataSource('Places', []);

    if (!isNullOrUndefined(lSelectedZone)) {
        if (!isNullOrUndefined(lNavigatedFromAddressZoneEdit)) {
            if (lNavigatedFromAddressZoneEdit.Value) {
                if (mZonesData.TempId !== lSelectedZone.Id) {
                    mZonesData.TempId = -1;
                    setViewState('NavigatedFromAddressZoneEdit', false);
                    setViewState('ZoneReturnEnrolleeId', null);
                }
            }
        };
        mZonesData.CurrentId = lSelectedZone.Id;
        mZonesData.EditItem = $.extend({}, getDataItem(mZonesData.CurrentId, 'Zones'));

        mZonesControls.CardViewTimer.SetTimer(function () {
            uCancelZoneButton_OnClick();
            PopulateZoneData(mZonesData.CurrentId);
        });

        uZoneEditDeleteButtons_SetVisibility();
        setViewState('ZonesSelectedZone', lSelectedZone.Id);
    }
}

function uZonesPaginator_OnPageChanged(aSender, aNewPage, aData) {
    "use strict";
    if (isNullOrUndefined(mZonesData.Dirty)) {
        mZonesData.Dirty = mZonesData.Clean;
    }
    if (!isNullOrUndefined(mZonesData.Dirty)) {
        mZonesData.Paginated = aSender.paginate(mZonesData.Dirty);
        mZonesControls.CardView.setDataSource(mZonesData.Paginated);
    }
    // localize here
    veritracks.localization.localizeTitle('#uZonesListHolder');
    setViewState('ZonesSelectedPage', aNewPage);
}

function uZonesCardViewFilter_OnFilter(aSender, aExpression, aData) {
    "use strict";
    var lBuilder,
        lIsEmpty,
        lSortState = getViewState('ZonesCardViewSort');
       

    if (isNullOrUndefined(mZonesData.Clean)) {
        mZonesData.Clean = [];
    }
    if (isNullOrUndefined(mZonesData.Sort)) {
        mZonesData.Sort = mZonesData.Clean;
    }

    if (mZonesData.TargetId === -1) {
        mZonesData.Dirty = query(mZonesData.Sort, aExpression);
        $('#uEnrolleeScheduleBackButton').hide();
        $('#uEnrolleeAddressBackButton').hide();
    } else {
        mZonesData.TempId = mZonesData.TargetId;
        lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', mZonesData.TargetId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        mZonesData.Dirty = query(mZonesData.Sort, lBuilder.RootExpression);
        mZonesData.TargetId = -1;
    }
    lIsEmpty = (mZonesData.Dirty.length === 0);
    veritracks.system.applyFilterState('Zones', lIsEmpty);
    if (isNullOrUndefined(mZonesControls.CardViewPaginator)) {
        gPaginatorFactory_OnZonesInit();
    }
    if (isNullOrUndefined(lSortState)) {
        mZonesData.Dirty = ZonesSortFormatter(mZonesData.Dirty)
    }
    mZonesData.Paginated = mZonesControls.CardViewPaginator.paginate(mZonesData.Dirty);
    mZonesControls.Map.layerSetDataSource('Zones', []);
    mZonesControls.Map.layerSetDataSource('ZonesNames', []);
    mZonesControls.CardView.setDataSource(mZonesData.Paginated);

    veritracks.localization.localizeTitle('#uZonesListHolder');
}

function zonesPlaces_OnComplete(aSender, aPlaceList) {
    "use strict";
    var lEditItem,
        lLocation,
        lLatitude,
        lLongitude;

    mZonesControls.NotificationPanel.clearNotifications();
    if (aPlaceList.length === 1) {
        lLocation = aPlaceList[0];
        lLatitude = lLocation.geometry.location.lat();
        lLongitude = lLocation.geometry.location.lng();
        if (!isNullOrUndefined(mZonesData.EditShape)) {
            if (veritracks.mapping.localityTypeMatch(lLocation.types[0])) {
                aPlaceList.shift();
                lEditItem = veritracks.mapping.moveZoneCenter(mZonesData.EditItem, mZonesControls.Map.layerGetShape('Zones', mZonesData.EditItem.Id), lLatitude, lLongitude);
                mZonesControls.Map.layerSetDataSource('Zones', veritracks.mapping.prepareZoneData([lEditItem]));
                mZonesData.EditShape = mZonesControls.Map.layerGetShape('Zones', mZonesData.EditItem.Id);
                if (!isNullOrUndefined(mZonesData.EditShape)) {
                    mZonesData.EditShape.setEditable(true);
                }
                mZonesControls.Map.fitBounds();
                $('#uZonesDetailTypeEdit').change();
            }
        } else {
            mZonesControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
            mZonesControls.Map.setCenter(lLatitude, lLongitude);
            mZonesControls.Map.zoom(17);
        }        
    } else if (aPlaceList.length >= 1) {
        lLocation = aPlaceList[0];
        lLatitude = lLocation.geometry.location.lat();
        lLongitude = lLocation.geometry.location.lng();
        mZonesControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));
        mZonesControls.Map.setCenter(lLatitude, lLongitude);
        mZonesControls.Map.zoom(14);
    } else {
        mZonesControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData(aPlaceList));       
    }    
}

function PopulateZoneData(aZoneId) {
    "use strict";
    var lZone = getDataItem(aZoneId, 'Zones'),
        lZoneShape,
        lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lCacheItem,
        lKey, ZoneClassificationId,
        lOrganizationVar = [];

    function PopulateRegularZoneData_OnSuccess(aParams, aData) {
        var lKey,
           lClassified = "Unclassified";

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                if (aData[lKey].ZoneClassificationId == lZone.ZoneClassificationId) {
                    lClassified = aData[lKey].ZoneClassificationName;
                }
            }
        }
        $('#uRiskLevel').hide();
        $('#uClassifiedZone').show();
        lZone.ClassifiedZone = lClassified;
        PopulateDetailView(lZone, {
            'AgentId': AgentNameFormatter,
            'OrganizationId': OrganizationNameFormatter,
            'Type': zoneTypeFormatter,
            'Scope': zoneScopeFormatter,
            'ClassifiedZone': zoneClassifiedZoneFormatter,
            'RiskLevel': zoneRiskLevelFormatter,
            'Shape': zoneShapeFormatter,
            'IsVisible': zoneIsVisibleFormatter,
            'Radius': zoneRadiusFormatter
        }, 'uZonesDetail');
        delete lZone.Classifiedzone;
    }

    if (!isNullOrUndefined(lZone.ZoneClassificationId) && lZone.ZoneClassificationId !== -1 && lZone.Scope != 1) {
        veritracks.mapping.zoneRiskLevel(lZone.OrganizationId, lZone.ZoneClassificationId, RiskLevelSuccess_OnSuccess);
        //veritracks.mapping.zoneClassifiedZone(lZone.OrganizationId, lZone.ZoneClassificationId, PopulateZoneData_OnSuccess);
    }
    else {
        veritracks.mapping.zoneClassifiedZone(lZone.OrganizationId, lZone.ZoneClassificationId, PopulateRegularZoneData_OnSuccess);
    }
    //}
    mZonesData.EditVertices = [];
    function RiskLevelSuccess_OnSuccess(lData, aData) {
        var lKey,
            lRiskLevel = [];
        if (!isNullOrUndefined(aData)) {
            for (lKey in aData) {
                if (aData.hasOwnProperty(lKey)) {
                    if (!isNullOrUndefined(aData[lKey].RiskLevelName)) {
                        lRiskLevel.push(aData[lKey].RiskLevelName);
                    }
                }
            }
        }
        lZone.RiskLevel = lRiskLevel;
        veritracks.mapping.zoneClassifiedZone(lZone.OrganizationId, lZone.ZoneClassificationId, PopulateZoneData_OnSuccess);
    }
    function PopulateZoneData_OnSuccess(lData, aData) {
        var lKey,
            lClassified;
        
        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                if (aData[lKey].ZoneClassificationId == lZone.ZoneClassificationId) {
                    lClassified = aData[lKey].ZoneClassificationName;
                }
            }
        }
        lZone.ClassifiedZone = lClassified;
        $('#uClassifiedZone').show();
        $('#uRiskLevel').show();
        PopulateDetailView(lZone, {
            'AgentId': AgentNameFormatter,
            'OrganizationId': OrganizationNameFormatter,
            'Type': zoneTypeFormatter,
            'Scope': zoneScopeFormatter,
            'ClassifiedZone': zoneClassifiedZoneFormatter,
            'RiskLevel' : zoneRiskLevelFormatter,
            'Shape': zoneShapeFormatter,
            'IsVisible': zoneIsVisibleFormatter,
            'Radius': zoneRadiusFormatter
        }, 'uZonesDetail');

        delete lZone.ClassifiedZone;
    }
    function onComplete(aParams, aZones, aVertices) {
        var lZone = aZones[0];
        mZonesControls.Map.layerSetDataSource('Zones', aZones);
        mZonesControls.Map.layerSetDataSource('ZonesNames', veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(aZones));

        mZonesControls.Map.fitBounds();
        mZonesData.EditVertices = [];
        var lZoneShape = parseInt(lZone.data.Shape);
        if (!isNullOrUndefined(lZone) && lZoneShape === 1) {
            $('#uRadiusRow').show();
        } else {
            $('#uRadiusRow').hide();
            if (!isNullOrUndefined(lZone) && !isNullOrUndefined(aVertices[lZone.id])) {
                if (lZoneShape === 2) {
                    mZonesData.EditVertices = aVertices[lZone.id];
                } else {
                    mZonesData.EditVertices = null;
                }
           } 
        }
    }
    if (!isNullOrUndefined(lZone)) {
        lZoneShape = lZone.Shape;
        veritracks.mapping.renderZones(mZonesControls.Map, 'Zones', [lZone], onComplete, lZone);
    } else {
        veritracks.mapping.renderZones(mZonesControls.Map, 'Zones', [], onComplete, lZone);
    }
}

function zonesEnterEditMode() {
    "use strict";
    var lNavigatedFromAddressZoneEdit = getViewState('NavigatedFromAddressZoneEdit');

    if (!isNullOrUndefined(lNavigatedFromAddressZoneEdit)) {
        if (lNavigatedFromAddressZoneEdit.Value) {
            $('#uEnrolleeScheduleBackButton').hide();
            $('#uEnrolleeAddressBackButton').hide();
        }
    }

    $('#uUniqueZoneError').hide();
    $('#uZoneBBGConnectionError').hide();
    $('#uEditZoneButton').hide();
    $('#uAddZoneButton').hide();

    mZonesControls.Map.layerHide('ZonesNames');
    mZonesControls.Map.layerSetDataSource('ZonesNames', veritracks.mapping.prepareZoneLabelOverlayData([]));

    $('#uSaveZoneButton').show();
    $('#uCancelZoneButton').show();
    EnterEditMode('uMapDetailsContent');
  //  $('#uZoneRadiusEditSubmit').hide();
    $('#uAddressCommandButtonHolder').hide();
    $('#uZoneDrawSection').hide();
}

function zonesExitEditMode() {
    "use strict";
    var lNavigatedFromAddressZoneEdit = getViewState('NavigatedFromAddressZoneEdit'),
        lReturnEnrolleeId = getViewState('ZoneReturnEnrolleeId');

    if (!isNullOrUndefined(lNavigatedFromAddressZoneEdit)) {
        if (lNavigatedFromAddressZoneEdit.Value === true) {
            $('#uEnrolleeAddressBackButton').show();
            if (hasProduct(lReturnEnrolleeId.Value, 103) || hasProduct(lReturnEnrolleeId.Value, 151) || isNullOrUndefined(gCurrentDeviceAssignment[lReturnEnrolleeId.Value]) || gCurrentDeviceAssignment[lReturnEnrolleeId.Value].length === 0) {
                $('#uEnrolleeScheduleBackButton').show();
            }
        }
    }
    $('#uEditZoneButton').show();
    $('#uAddZoneButton').show();
    $('#uSaveZoneButton').hide();
    $('#uCancelZoneButton').hide();
    $('#uResetZoneButton').hide();
    ExitDrawMode();
    $('#uZoneScopeAlert').hide();
    $('#uAddressCommandButtonHolder').show();
    ExitEditMode('uMapDetailsContent');
    $('.ZonesDetailVisibility').show();
    $('#uZonesListHolder').show();
    mZonesData.EditMode = false;
    $('#uClassifiedZone').show();

}

function ExitDrawMode() {
    $('#uRestartDrawZoneButton').hide();
    $('#uZonesDetailDrawModeEdit').attr('checked', false);
    if (mZonesControls.drawingManager)
        mZonesControls.drawingManager.setMap(null);

    if (mZonesData.EditShape)
        mZonesData.EditShape.setMap(null);

    mZonesControls.drawingManager = null;
    mZonesData.EditShape = null;
}

function uZonesClassifiedZone_OnChange() {
    "use strict";
    mZonesData.SelectedOri = parseInt($('#uZonesDetailZoneClassificationIdEdit').val());
    if ($('#uClassifiedZone').css('display') == 'none') {
        mZonesData.SelectedOri = -1;
    }
}

function uZonesDetailOrganizationIdEdit_OnChange() {
    "use strict";
    var lId = -1,
        lBuilder = new SumoPredicateBuilder(),
        lRiskLevelBuilder = new SumoPredicateBuilder(),
        lRiskLevels,
        lOrganizationId = $('#uZonesDetailOrganizationIdEdit').val(),
        lAgents,
        lMyAgents,
        lKey,
        lT;

    lBuilder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lAgents = query(getDataItems('Agents'), lBuilder.RootExpression);

    lBuilder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lMyAgents = query(getDataItems('Agents'), lBuilder.RootExpression);
    if (lMyAgents.length > 0) {
        for (lKey in lMyAgents) {
            mZonesData.EditItem.AgentId = lMyAgents[lKey].Id;
            break;
        }
    }
    populateEditView({ 'AgentId': mZonesData.EditItem.AgentId }, [
            { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': lAgents, 'DataValueField': 'Id', 'DataTextField': 'FullName' }
    ], {}, 'uZonesDetail', 'Edit');

    zoneClassifiedZoneView();
   // zoneRiskLevelView();


}

function zoneClassifiedZoneView() {
    "use strict";
    var lOrganizationId = $('#uZonesDetailOrganizationIdEdit').val(),
        lRiskLevels,
        lData = -1,
        isEdit;

    if (isNullOrUndefined(lOrganizationId)) {
        lOrganizationId = mZonesData.EditItem.OrganizationId;
    }

    if (mZonesData.EditItem.Name !== "") {
        veritracks.mapping.zoneClassifiedZone(lOrganizationId, lData, ZoneClassified_OnSuccess);
    }
    else {
        veritracks.mapping.zoneClassifiedZone(lOrganizationId, lData, ZoneClassified_OnSuccess);
    }

    function ZoneClassified_OnSuccess(lreturnData, aData) {
        "use strict";
        if (!isNullOrUndefined(aData)) {
            var defaultData = new OriZoneClassification(),
                lClassifiedZoneId;

            aData.push({ Id: -1, ZoneClassificationId: -1, ZoneClassificationName: "Unclassified" });

            lClassifiedZoneId = mZonesData.EditItem.ZoneClassificationId;
            populateEditView({ 'ZoneClassificationId': lClassifiedZoneId }, [
                { 'Id': 'ZoneClassificationId', 'Type': 'Dropdown', 'DataSource': aData, 'DataValueField': 'ZoneClassificationId', 'DataTextField': 'ZoneClassificationName' }
                ], {}, 'uZonesDetail', 'Edit');
        }
       // delete aData[0];
        ZoneClassified_OnComplete(aData);
    }

    function ZoneClassified_OnComplete(aData) {
        "use strict";
        mZonesData.Classifiedzone = aData;
        if (ObjectLength(mZonesData.Classifiedzone) > 0) {
            $('#uZonesDetailsScope').show();
        }
        uZoneClassifiedZonesCheck();
    }
}
function zonePopulateEditView() {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lRiskLevelBuilder = new SumoPredicateBuilder(),
        lAgents,
        lShape,
        lRiskLevels,
        lKey,
		lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
        risk = [],
        lisZoneVisibilityEditable = veritracks.system.clientSetting('EditableZoneVisibility'),
        lOrganizations;
        //lZoneRiskLevel = mZonesData.EditItem.OrganizationId;


    if (!isNullOrUndefined(mZonesData.EditItem)) {
        lBuilder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lOrganizations = query(OrganizationSortFormatter(), lBuilder.RootExpression);
        lBuilder.Clear();
		if (lDoMetric) {
            mZonesData.EditItem.Radius = Math.round(convertFeetToMeters(mZonesData.EditItem.Radius));
        } else {
            mZonesData.EditItem.Radius = Math.round(mZonesData.EditItem.Radius);
        }
        lBuilder.AddNewExpressionConditional('OrganizationId', mZonesData.EditItem.OrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lAgents = query(getDataItems('Agents'), lBuilder.RootExpression);

        var lTypes = [];
        $('#uZoneRadiusDropdownEdit').empty();
        lTypes.push(new Option(localizeText('cPleaseSelect'), ''));
        lTypes.push(new Option(localizeText('cZoneLengthFive'), 5));
        lTypes.push(new Option(localizeText('cZoneLengthTen'), 10));
        lTypes.push(new Option(localizeText('cZoneLengthTwentyFive'), 25));
        lTypes.push(new Option(localizeText('cZoneLengthFifty'), 50));
        $('#uZoneRadiusDropdownEdit').append(lTypes);


        populateEditView(mZonesData.EditItem, [
            { 'Id': 'AgentId', 'Type': 'Dropdown', 'DataSource': AgentsSortFormatter(lAgents), 'DataValueField': 'Id', 'DataTextField': 'FullName' },
            { 'Id': 'OrganizationId', 'Type': 'Dropdown', 'DataSource': lOrganizations, 'DataValueField': 'Id', 'DataTextField': 'Name' },
            { 'Id': 'Type', 'Type': 'Dropdown', 'DataSource': getDataItems('ZoneType'), 'LocaleName': 'ZoneType', 'DataValueField': 'Id', 'DataTextField': 'Description','Class':'Validate ValidateRequired ValidateNotNull','insertBlank':true },
            { 'Id': 'Scope', 'Type': 'Dropdown', 'DataSource': [{ 'Id': 1, 'Description': localizeText('cZoneScopeRegular') }, { 'Id': 3, 'Description': localizeText('cZoneScopeGlobal') }], 'DataValueField': 'Id', 'DataTextField': 'Description' },
            { 'Id': 'Shape', 'Type': 'Dropdown', 'DataSource': getDataItems('ZoneShape'), 'LocaleName': 'ZoneShape', 'DataValueField': 'Id', 'DataTextField': 'Description' },
            { 'Id': 'IsVisible', 'Type': 'Dropdown', 'DataSource': [{ 'Value': true, 'Text': localizeText('cZoneShown') }, { 'Value': false, 'Text': localizeText('cZoneHidden') }], 'DataValueField': 'Value', 'ComparisonType': 'Boolean', 'DataTextField': 'Text' },
            //{ 'Id': 'RiskLevel', 'Type': 'Dropdown', 'DataSource': [{ 'Id': 1, 'Description': 'Dog' }, { 'Id': 2, 'Description': 'cat' }]/*getDataItems('ZonesRiskLevel')*/, 'DataValueField': 'Id', 'DataTextField': 'Description' }
        ], {'Name':veritracks.system.decodeHtml,'Description':veritracks.system.decodeHtml}, 'uZonesDetail', 'Edit', localizeDataItem);
        mZonesControls.Validator = new Validator('uMapDetailsContent', mRegexValidation);
        // edit list view for risk levels
        zoneClassifiedZoneView();
        zonesEnterEditMode();

        if (mZonesData.EditItem.Shape == 2) {
            $('#uZoneDrawSection').show();
        }

        mZonesData.EditShape = veritracks.mapping.editZone(mZonesControls.Map, 'Zones', mZonesData.EditItem);
        if (lisZoneVisibilityEditable) {
            $('.ZonesDetailVisibility').hide();
            $('#uZonesDetailIsVisibleEdit').hide();
        }

    }
}

function uAddZoneButton_OnClick() {
    "use strict";
    //$('#uAddressCommandButtonHolder').hide();
    $('#uZonesListHolder').hide();
    $('#uEnrolleeScheduleBackButton').hide();
    $('#uEnrolleeAddressBackButton').hide();
    $('#uRiskLevel').hide();
    var lCenter = mZonesControls.Map.getCenter(),
    lShape = parseInt($('#uZonesDetailShapeEdit').val());
    mZonesData.EditVertices = null;
    mZonesData.EditItem = new Zone();
    mZonesData.EditItem.Radius = 150.00;
    mZonesData.EditItem.CenterLatitude = lCenter.lat();
    mZonesData.EditItem.CenterLongitude = lCenter.lng();
    mZonesControls.Map.layerSetDataSource('Zones', veritracks.mapping.prepareZoneData([mZonesData.EditItem]));
    $('#uDetailsHolder').show();
    $('#uMapDetailsContent').show();
    // zonesEnterEditMode();
    $('#uZoneRadiusEdit').val(mZonesData.EditItem.Radius);
    $("#uZoneRadiusDropdownEdit").val("");
    zonePopulateEditView();
    uZonesDetailOrganizationIdEdit_OnChange();
    uZoneEditDeleteButtons_SetVisibility();
    $("#uRadiusRow").show();
    $('#uZoneRadiusEditSubmit').show();
}


function uEditZoneButton_OnClick() {
    "use strict";
    var lZoneId = mZonesControls.CardView.selected(),
        lZones = getDataItems('Zones'),
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));

                

    $('#uRiskLevel').hide();
    //$('#uAddressCommandButtonHolder').hide();
    mZonesData.EditItem = $.extend({}, getDataItem(mZonesData.CurrentId, 'Zones'));
    mZonesData.EditMode = true;
    zonePopulateEditView();
    //uZoneClassifiedCheckbox_OnClick();
    if (mZonesData.EditItem.Shape === 2) {
        $('#uResetZoneButton').show();
        $('#uRadiusRow').hide();
        $('#uZoneRadiusEditSubmit').hide();
    } else {
        var lZoneRadius;
        if (lDoMetric) {
            lZoneRadius = convertFeetToMeters(lZones[lZoneId].Radius);
        } else {
            lZoneRadius = Math.round(lZones[lZoneId].Radius);
        }
        $('#uZoneRadiusEdit').val(lZoneRadius);
        $('#uZoneRadiusEditSubmit').show();
    }
    
    if (mZonesData.EditItem.IsVisible === true) {
        $('#uZonesDetailIsVisibleEdit').val('true');
    } else {
        $('#uZonesDetailIsVisibleEdit').val('false');
    }
    $('#uDeleteZoneButton').hide();
    $("#uZoneRadiusDropdownEdit").val("");

}

function uCancelZoneButton_OnClick() {
    "use strict";

    //$('#uAddressCommandButtonHolder').show();
    if ($('#uCancelZoneButton').is(':visible')) {
        $('#uZonesListHolder').show();
        PopulateZoneData(mZonesData.CurrentId);
        mZonesData.EditItem = null;
        ExitDrawMode();
        mZonesData.EditShape = null;
        zonesExitEditMode();
        veritracks.system.applyControlState('Zones', mZonesControls.CardView);
        uZoneEditDeleteButtons_SetVisibility();
        $("#uZoneRadiusEditSubmit").hide();
        mZonesControls.Map.layerShow('ZonesNames');
        $("#uRadiusRow").show();
        //$('#uClassifiedZone').hide();
        //$('#uRiskLevel').show();
    }
}

function uResetZoneButton_OnClick() {
    "use strict";
    uZonesDetailShapeEdit_OnChange();
    veritracks.mapping.resetZone(mZonesControls.Map, 'Zones', mZonesData.EditItem.Id);
}

function zoneWriteSingle_OnRender(aSender, aData, aParams) {
    "use strict";
    $('#uZonesListHolder').show();
    mZonesControls.CardViewFilter.unbind('filter', zoneWriteSingle_OnRender);
    mZonesControls.CardView.selected(aParams);
    $("#uZoneRadiusEditSubmit").hide();
    mZonesControls.Map.layerShow('ZonesNames');
}

function zonesWrite_OnComplete(aZone, aIsNew) {
    "use strict";
    var lReturnEnrolleeId = getViewState('ZoneReturnEnrolleeId'),
        lCardView = mZonesControls.CardView.getDataSource();
    var lDrawingModeUsed = $('#uZonesDetailDrawModeEdit').is(':checked');
    if (aZone.Id <= 0) {
        $('#uUniqueZoneError').show();

        uZonesDetailShapeEdit_OnChange();
        $('#uSaveZoneButton').show();
        $('#uCancelZoneButton').show();
    } else {
        if (mZonesData.EditShape)
            mZonesData.EditShape.setMap(null);

        mZonesData.CurrentId = aZone.Id
        mZonesData.EditItem = null;
        mZonesData.EditShape = null;
        mZonesData.EditVertices = [];
        zonesDataListConverter();
        universalSearch_UpdateData();
        zonesExitEditMode();
        uZoneEditDeleteButtons_SetVisibility();
        $('#uZonesListHolder').show();
        $('#uUniqueZoneError').hide();
        $('#uZoneBBGConnectionError').hide();
        mZonesControls.Map.layerShow('ZonesNames');
        if (aIsNew) {
            setViewState('NavigatedFromAddressZoneEdit', false);
            setViewState('ZoneReturnEnrolleeId', null);
            window.location.hash = 'Zones.Map.' + aZone.Id;
        } else {
            if (lCardView.length == 1) {
                mZonesData.TargetId = aZone.Id;
            }
            mZonesControls.CardViewFilter.bind('filter', zoneWriteSingle_OnRender, aZone.Id);
            if (!isNullOrUndefined(lReturnEnrolleeId) && $('#uEnrolleeAddressBackButton').is(':visible')) {
                mZonesData.TargetId = aZone.Id;
            }
            mZonesControls.CardViewFilter.filter();
        }
        //if (lDrawingModeUsed)
        //    window.setTimeout(setDrawingModeAsDefaultForPolygon, 2000);
        hideLoadingBar('uZonesMainContentPanel');
    }
}

function zonesEditItem_Save() {
    "use strict";
    showLoadingBar('uZonesMainContentPanel');
    uZonesClassifiedZone_OnChange();
    var mtest = mZonesData.SelectedOri;
    if (mZonesData.SelectedOri == -1 || isNullOrUndefined(mZonesData.SelectedOri)) {
        mZonesData.EditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        veritracks.mapping.saveZone(mZonesData.EditItem, mZonesData.EditVertices, mZonesData.EditShape, zonesWrite_OnComplete);
    }
    else {
        mZonesData.EditItem.TransactionId = moment().format("YYYYMMDDHHmmss");
        veritracks.mapping.saveZone(mZonesData.EditItem, mZonesData.EditVertices, mZonesData.EditShape, zonesWrite_OnComplete, mZonesData.SelectedOri);
    }

}

function uSaveZoneButton_OnClick() {
    "use strict";
    
    if (mZonesData.EditMode && $("#uZonesDetailScopeEdit").val() == 3) {
        if ($('#uClassifiedZone').is(":hidden")) {
            $('#uZoneScopeAlert').show();
        }
        else {
            $('#uZoneScopeAlert').hide();
            saveZone();
        }
    } else {
        saveZone();
    }

    function saveZone() {
        var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
            lZoneRadius = $('#uZoneRadiusEdit').val();

        if (mZonesControls.Validator.IsValid()) {
            if (!isNullOrUndefined(mZonesData.EditItem)) {
                populateFromEditView(mZonesData.EditItem, 'uZonesDetail', 'Edit');
                var classifiedZone = mZonesData.Classifiedzone.find(function (classified) {
                    return classified.ZoneClassificationId == mZonesData.EditItem.ZoneClassificationId
                })
                mZonesData.EditItem.UpdatedByAppUserId = gUserDetails.UserId;

                if (!classifiedZone) {
                    $('#uZoneScopeAlert').show();
                    return;
                }
                //mZonesData.EditItem.ClassifiedZone = classifiedZone.ZoneClassificationName;

                if (lZoneRadius) {
                    if (lDoMetric) {
                        mZonesData.EditItem.Radius = Math.round(convertMetersToFeet(parseInt(lZoneRadius)));                       
                    }
                    else {
                        mZonesData.EditItem.Radius = Math.round(parseInt(lZoneRadius));
                    }
                }

                $('#uSaveZoneButton').hide();
                $('#uCancelZoneButton').hide();
                $('#uResetZoneButton').hide();
                $('#uRestartDrawZoneButton').hide();
                $('#uUniqueZoneError').hide();
                $('#uZoneBBGConnectionError').hide();

                // Vulnerability 3253
                mZonesData.EditItem.Name = veritracks.system.encodeHtml(mZonesData.EditItem.Name);
                mZonesData.EditItem.Description = veritracks.system.encodeHtml(mZonesData.EditItem.Description);

                mActivityNotification.addNotification(localizeWrapper('cZoneSaving') + mZonesData.EditItem.Name);
                zonesEditItem_Save();
               
            }
        }
      
    }

}

function setDrawingModeAsDefaultForPolygon() {
    "use strict";
    var lUserPreferences = getUserPreferences(15);

    if (isNullOrUndefined(lUserPreferences['DrawModePreference'])) {
        var lHtml = [];
        var lButtonCommandBar = GenerateButtonCommandBar();

        lHtml.push('<div> <strong> Would you like to set drawing mode as the default when creating polygon zones? </div>')
        lHtml.push('<div> You can always go back and change your preference in your profile settings. </div>')

        GenerateButton('Set as Default', 'Save', function () {
            setDefaultDraw(1);
        }).appendTo(lButtonCommandBar);
        GenerateButton(localizeWrapper('cEnrolleeCancel'), 'Cancel', declineDefaultDraw).appendTo(lButtonCommandBar);

        DisplayPopup('Set Drawing Polygons as Default?', lHtml.join(''), lButtonCommandBar, false, false, declineDefaultDraw)
    }
}

function setDefaultDraw() {
    var lPreference = new UserPreference();
    lPreference.ColumnName = 'DrawModePreference';
    lPreference.UserPreferenceType = 15;
    lPreference.Value = 1;
    lPreference.Id = gUserDetails.UserId;
    writeUserPreferences([lPreference]);
    mActivityNotification.addNotification('Drawing mode set as default.....');
    ClosePopup();
}

function declineDefaultDraw() {
    var lPreference = new UserPreference();
    lPreference.ColumnName = 'DrawModePreference';
    lPreference.UserPreferenceType = 15;
    lPreference.Value = 0;
    lPreference.Id = gUserDetails.UserId;
    writeUserPreferences([lPreference]);
    ClosePopup();
}

function uDeleteZoneButton_OnClick() {
    "use strict";
    var lVertices,
        lItem,
        lBuilder = new SumoPredicateBuilder(),
        lKey;

    function zoneEnrolleeAddressWriteMultiple_OnSuccess(aParams, aData) {
        var l = '';
        $("#uDeleteZoneButton").hide();
    }

    function zoneEnrolleeAddressWriteMultiple_OnFailure(aParams, a, b, c) {
        var l = '';
    }

    function zoneEnrolleeAddress_OnSuccess(aParams, aData) {
        var lItem,
            lEnrolleeAddresses = [],           
            lKey;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                lItem.ZoneId = -1;
                lEnrolleeAddresses.push(lItem);
            }
        }
        if (lEnrolleeAddresses.length > 0) {
            WriteMultiple(lEnrolleeAddresses, zoneEnrolleeAddressWriteMultiple_OnSuccess, zoneEnrolleeAddressWriteMultiple_OnFailure, lEnrolleeAddresses, true);
        } else {
            $('#uDeleteZoneButton').hide();
        }
    }

    function zoneVertexDeleteFind_OnSuccess(aParams, aData) {
        var lActiveVertex = [];
        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                lActiveVertex.push(false);
            }
        }
        mZonesData.EditItem.IsVertexActive = lActiveVertex.join(",");

        mActivityNotification.addNotification(localizeWrapper('cZoneDeleting') + mZonesData.EditItem.Name);
        $('#uClassifiedZone').hide();
        zonesEditItem_Save();
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('ZoneId', mZonesData.EditItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, zoneEnrolleeAddress_OnSuccess, null, null, null, 0);
    }

    mZonesData.EditItem = $.extend({}, getDataItem(mZonesData.CurrentId, 'Zones'));
    mZonesData.EditItem.IsActive = false;
    if (mZonesData.EditItem.Shape === 2) {
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('ZoneId', mZonesData.EditItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.ZoneVertex.AssemblyQualifiedName, lBuilder.RootExpression, 0, zoneVertexDeleteFind_OnSuccess, null, null, null, 0);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cZoneDeleting') + mZonesData.EditItem.Name);
        $('#uClassifiedZone').hide();
        zonesEditItem_Save();
        lBuilder.Clear();
        lBuilder.AddNewExpressionConditional('ZoneId', mZonesData.EditItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList.EnrolleeAddress.AssemblyQualifiedName, lBuilder.RootExpression, 0, zoneEnrolleeAddress_OnSuccess, null, null, null, 0);
    }   
   
}

function uZonesDetailTypeEdit_OnChange() {
    "use strict";
    var lType = parseInt($('#uZonesDetailTypeEdit').val());
    var lBuilder = new SumoPredicateBuilder();
    var lResults = [];


    $('#uZoneBBGConnectionError').hide();
    $('#uSaveZoneButton').show();

    if (lType == 2 && mZonesData.EditItem.Id !== -1) {
        lBuilder.AddNewExpressionConditional('ZoneId', mZonesData.EditItem.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lResults = query(getDataItems('DeviceClusters'), lBuilder.RootExpression);
        if (lResults.length > 0) {
            $('#uZoneBBGConnectionError').show();
            $('#uSaveZoneButton').hide();
        }
    }

    veritracks.mapping.changeColor(mZonesControls.drawingManager, lType, 'polygonOptions');
    veritracks.mapping.changeColorOfShape(mZonesData.EditShape, lType);
}

function uZonesScopeEdit_OnChange() {
    "use strict";
    var lScope = parseInt($('#uZonesDetailScopeEdit').val()),
        lCurrentScope = mZonesData.EditItem.Scope,
        lEnrolleeCount = mZonesData.EditItem.EnrolleeCount,
        lButtonCommandBar = GenerateButtonCommandBar();
    $(GenerateButton(localizeWrapper('cOk'), '', 'ClosePopup()')).appendTo(lButtonCommandBar);
    if (lCurrentScope === 1 && lScope === 3 && lEnrolleeCount > 0) {
        $("#uZonesDetailScopeEdit").val('1');
        DisplayPopup(localizeWrapper('cError'), '<div id="">'+localizeWrapper('cZoneGlobalAssignedScopeError')+'</div>', lButtonCommandBar, true);
    }
    else if (lScope == 3 && lEnrolleeCount == 0) {
        $('#uZonesDetailTypeEdit').val(2);
        var lAllowInclusion = veritracks.system.clientSetting('AllowGlobalInclusionZone');
        // get client property

        if (!lAllowInclusion) {
            $('#uZonesDetailTypeEdit')[0].options[0].disabled = true;
        }

        uZonesDetailTypeEdit_OnChange()
    } else {
        $('#uZonesDetailTypeEdit')[0].options[0].disabled = false;
    }
    uZoneClassifiedZonesCheck();
}

function uZoneClassifiedZonesCheck() {
    "use strict";
     
    var classifiedLength = 0,
        lZone = getDataItem(mZonesData.CurrentId, 'Zones');

    if (!isNullOrUndefined(mZonesData.Classifiedzone.length)) {
        classifiedLength = mZonesData.Classifiedzone.length;
    }
    if (!isNullOrUndefined(mZonesData.Classifiedzone) && classifiedLength > 0) {
            var lScope = parseInt($('#uZonesDetailScopeEdit').val()),
                lType = parseInt($('#uZonesDetailTypeEdit').val());
            $('#uClassifiedZone').show();
            if (lScope == 3) {
                $('#uZonesDetailZoneClassificationIdEdit option[value="-1"]').remove()
            } else {
                if ($('#uZonesDetailZoneClassificationIdEdit option[value="-1"]').length == 0) {
                    $('#uZonesDetailZoneClassificationIdEdit').append($("<option></option>")
                        .attr("value", -1)
                        .text("Unclassified"));
                }
            }
    }
    else {
        if (!mZonesData.EditMode) {
            $('#uZonesDetailsScope').hide();
            $('#uZonesDetailScopeEdit').val(1);
        }
        uZoneClassifiedZonesCheckFail();
    }
}


function uZoneClassifiedZonesCheckFail() {
    "use strict";

    $('#uClassifiedZone').hide();
    $('#uZonesDetailZoneClassificationIdEdit').val(-1);
    uZonesClassifiedZone_OnChange();
}

function uZonesDetailShapeEdit_OnChange() {
    "use strict";
    var lShape = parseInt($('#uZonesDetailShapeEdit').val()),
        lCenter = mZonesControls.Map.getCenter(),
        lVertices = [],
        lType,
        lZone = mZonesData.EditItem;
        //lZone = $.extend({}, mZonesData.EditItem);
    lZone.Shape = lShape;


    $('#uRestartDrawZoneButton').hide();
    $('#uZoneDrawSection').hide();
    $('#uZonesDetailDrawModeEdit').attr('checked', false);

    if (lShape === 1) {
        $('#uResetZoneButton').hide();
        $('#uRestartDrawZoneButton').hide();
        $('#uRadiusRow').show();
        $('#uZoneRadiusEditSubmit').show();
        if (lZone.Radius === 0) {
            lZone.Radius = 91;
            $('#uZoneRadiusEdit').val(lZone.Radius);
        }
        if (lZone.CenterLatitude === 0) {
            lZone.CenterLatitude = lCenter.lat();
        }
        if (lZone.CenterLongitude === 0) {
            lZone.CenterLongitude = lCenter.lng();
        }
       
    } else {
        $('#uZoneDrawSection').show();
        $('#uResetZoneButton').show();
        $('#uRadiusRow').hide();
        $('#uZoneRadiusEditSubmit').hide();
        lVertices.push({ 'latitude': lCenter.lat(), 'longitude': lCenter.lng() });
        lZone.vertices = lVertices;
    }
    mZonesControls.Map.layerSetDataSource('Zones', veritracks.mapping.prepareZoneData([lZone]));
    mZonesData.EditShape = mZonesControls.Map.layerGetShape('Zones', lZone.Id);
    mZonesData.EditShape.setEditable(true);
    if (lShape === 2) {
       veritracks.mapping.resetZone(mZonesControls.Map, 'Zones', lZone.Id);
    }
    lType = parseInt($('#uZonesDetailTypeEdit').val());
    veritracks.mapping.changeColorOfShape(mZonesData.EditShape, lType);
    hideLoadingBar('uZonesMainContentPanel');
    //mZonesControls.Map.fitBounds();
}


//-----------
// Formatters
//-----------
//function ZoneNameFormatter(aId) {
//    "use strict";
//    var lName = 'Unknown',
//        lObject = GetZone(aId);

//    if (lObject !== null) {
//        lName = lObject.Name;
//    }

//    return lName;
//}

//function zoneTypeFormatter(aId) {
//    "use strict";
//    return dataItemFormatter('ZoneType', 'Description', 'Unknown', aId);
//}

//function zoneScopeFormatter(aId) {
//    "use strict";
//    return dataItemFormatter('ZoneScope', 'Description', 'Unknown', aId);
//}

//function zoneShapeFormatter(aId) {
//    "use strict";
//    return dataItemFormatter('ZoneShape', 'Description', 'Unknown', aId);
//}

function zoneRadiusFormatter(aId) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric')),
        lUnit;

    if (lDoMetric) {
        lUnit = convertFeetToMeters(aId);
    } else
        lUnit = aId;

    return Math.round(lUnit) * 1.00;
}

//------------
// Data Access
//------------
function GetZone(aId) {
    "use strict";
    var lResult = null,
        lObject = getDataItem(aId, 'Zones');

    if (!isNullOrUndefined(lObject)) {
        lResult = lObject;
    }
    return lResult;
}

function GetZones(aOrganizationId, aScope, aType, aName) {
    "use strict";
    var lResults = null;
    var lBuilder = new SumoPredicateBuilder();

    if (aName) {
        lBuilder.AddNewExpressionConditional('Name', aName, false, mRelationalOperatorEnum.Like(), mLogicalOperatorEnum.And());
    }
    if (aScope) {
        lBuilder.AddNewExpressionConditional('Scope', aScope, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    if (aType) {
        lBuilder.AddNewExpressionConditional('Type', aType, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    }
    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsVisible', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('OrganizationId', aOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lResults = query(getDataItems('Zones'), lBuilder.RootExpression);

    return lResults;
}

//function GetRiskLevel(aid) {
//    var lBuilder = new SumoPredicateBuilder();

//    lBuilder.AddNewExpressionConditional('Id', aId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
//    lQuery = query(getDataItems('RiskLevels'), lBuilder.RootExpression);
//}

function zonesDistanceToolBar_OnClick() {
    "use strict";
    if (mZonesData.DistanceToolActive) {
        mZonesData.DistanceToolActive = false;
        //$('#uDistanceToolCommandButton').removeClass('Selected');
        $('.DistanceToolBarButton').removeClass('Selected');
        mZonesData.DistancePoints = [];
        mZonesControls.Map.layerSetDataSource('DistancePoints', []);
        mZonesControls.Map.layerSetDataSource('DistanceLabels', []);
        mZonesControls.Map.layerSetDataSource('ConnectedDistancePoints', []);
    } else {
        mZonesData.DistanceToolActive = true;
        //$('#uDistanceToolCommandButton').addClass('Selected');
        $('.DistanceToolBarButton').addClass('Selected');
    }
}

function zonesCalculateDistance_OnComplete(aDistance, aLatitude, aLongitude) {
    "use strict";
    mZonesControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([{ 'latitude': aLatitude, 'longitude': aLongitude, 'text': aDistance }]));
    mZonesControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData(mZonesData.DistancePoints));
}

function zonesCalculateDistance_OnClick(aClickData) {
    "use strict";
    var lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));

    if (lDoMetric) {
        zonesCalculateDistance(aClickData, new Unit().MEASURE.METRIC);
    } else {
        zonesCalculateDistance(aClickData);
    }
}


function zonesCalculateDistance(aClickData, aUnit) {
    "use strict";
    var lLatitude = aClickData.latLng.lat(),
        lLongitude = aClickData.latLng.lng(),
        lResult,
        lCard;
    if (mZonesData.DistanceToolActive === true) {
        if (!isNullOrUndefined(lLatitude) && !isNullOrUndefined(lLongitude)) {
            if (mZonesData.DistancePoints.length >= 2) {
                mZonesData.DistancePoints = [];
                mZonesControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData([]));
                mZonesControls.Map.layerSetDataSource('DistanceLabels', veritracks.mapping.prepareDistanceLabelOverlayData([]));
                mZonesControls.Map.layerSetDataSource('ConnectedDistancePoints', veritracks.mapping.prepareTripPointLineSegmentData([]));
            }
            lCard = new DistanceCard();
            lCard.latitude = lLatitude;
            lCard.longitude = lLongitude;
            if (isNullOrUndefined(mZonesData.DistancePoints)) {
                mZonesData.DistancePoints.push(lCard);
            } else {
                mZonesData.DistancePoints.push(lCard);
            }
            if (mZonesData.DistancePoints.length > 1) {
                if (isNullOrUndefined(aUnit)) {
                    lResult = veritracks.mapping.calculateDistances(mZonesData.DistancePoints[0].latitude, mZonesData.DistancePoints[0].longitude, mZonesData.DistancePoints[1].latitude, mZonesData.DistancePoints[1].longitude);
                }
                else {
                    if (aUnit.name == "Metric") {
                        lResult = veritracks.mapping.calculateDistancesMetric(mZonesData.DistancePoints[0].latitude, mZonesData.DistancePoints[0].longitude, mZonesData.DistancePoints[1].latitude, mZonesData.DistancePoints[1].longitude);
                    } else {
                        lResult = veritracks.mapping.calculateDistances(mZonesData.DistancePoints[0].latitude, mZonesData.DistancePoints[0].longitude, mZonesData.DistancePoints[1].latitude, mZonesData.DistancePoints[1].longitude);
                    }
                }
                zonesCalculateDistance_OnComplete(lResult.distanceDisplay, lResult.endPoint.latitude, lResult.endPoint.longitude);
            }
            mZonesControls.Map.layerSetDataSource('DistancePoints', veritracks.mapping.prepareDistanceMarkerData(mZonesData.DistancePoints));
        }
    }
}

function uRestartDrawZoneButton_OnClick() {
    mZonesControls.Map.layerSetDataSource('Zones', []);
    if (mZonesControls.drawingManager)
        mZonesControls.drawingManager.setMap(null);

    if (mZonesData.EditShape)
        mZonesData.EditShape.setMap(null);

    mZonesControls.drawingManager = null;
    mZonesData.EditShape = null;

    initiateDraw();
}


function initiateDraw() {
    var check = $('#uZonesDetailDrawModeEdit').is(":checked");
    if (!check) {
        if (mZonesControls.drawingManager)
            mZonesControls.drawingManager.setMap(null);

        if (mZonesData.EditShape)
            mZonesData.EditShape.setMap(null);

        mZonesControls.drawingManager = null;
        mZonesData.EditShape = null;

        uZonesDetailShapeEdit_OnChange();
        $('#uSaveZoneButton').show();

        return;
    }

    $('#uSaveZoneButton').hide();

    var lZoneType = parseInt($('#uZonesDetailTypeEdit').val());

    var lColor = "";

    if (lZoneType === 1) { // inclusion
        lColor = '#55d400'; // green
    } else { // exclusion
        lColor = '#d40000'; // red
    }

    $('#uResetZoneButton').hide();
    $('#uRestartDrawZoneButton').show();

   mZonesControls.drawingManager = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        polygonOptions: {
            fillColor: lColor,
            fillOpacity: 0.3,
            strokeWeight: 2,
            strokeColor: lColor,
            strokeOpacity: 0.65,
            clickable: false,
            editable: true,
            zIndex: 1
        }
    });

   mZonesControls.drawingManager.setOptions({
        drawingControl: false
    });

   mZonesControls.Map.layerSetDataSource('Zones', []);

   mZonesControls.drawingManager.setMap(mZonesControls.Map.getMap())
   mZonesData.EditShape = null;
   google.maps.event.addListener(mZonesControls.drawingManager, 'polygoncomplete', function (polygon) {
       mZonesData.EditShape = polygon;
       
       $('#uSaveZoneButton').show();

       mZonesControls.drawingManager.setDrawingMode(null);
   });
}

function uZoneRadiusDropdown_OnChange() {
    "use strict";
    var lRadius = $('#uZoneRadiusDropdownEdit').val(),
        lRadiusMeasurement,
        lDoMetric =  parseInt(getUserPreferenceValue(13,'ShowMetric'));
        
    if (lRadius !== "") {
        if (lDoMetric) {
            lRadiusMeasurement = convertKilometersToMeters(lRadius);
        } else {
            lRadiusMeasurement = sumo.geo.conversion.statuteMilesToFeet(lRadius);
        }
        $('#uZoneRadiusEdit').val(Math.round(lRadiusMeasurement));
    }
}


function uEnrolleeAddressBackButton_OnClick() {
    "use strict";
    var lReturnEnrolleeId = getViewState('ZoneReturnEnrolleeId');

    if (!isNullOrUndefined(lReturnEnrolleeId)) {
        window.location.hash = 'Enrollees.Offenders.Profile.Addresses.' + lReturnEnrolleeId.Value;
    }
}

function uEnrolleeScheduleBackButton_OnClick() {
    "use strict";
    var lReturnEnrolleeId = getViewState('ZoneReturnEnrolleeId'),
        lCard = mZonesControls.CardView.selectedDataItem();
    if (!isNullOrUndefined(lCard) && !isNullOrUndefined(lReturnEnrolleeId)) {
        enrolleesScheduleZonesDataListConverter();
        setViewState('ZoneScheduleId', lCard.Id);
        setViewState('ZoneScheduleEnrolleeId', lReturnEnrolleeId.Value);
        if (displayOldScheduleUILoggedInOri(lReturnEnrolleeId.Value)) {
            window.location.hash = 'Enrollees.Offenders.Profile.Schedules.' + lReturnEnrolleeId.Value;
        }else {
            mEnrolleesData.SchedulesTargetsClean = $.extend({}, mEnrolleesData.SchedulesZonesClean);
            mEnrolleesData.CarveOutTargetsClean = [];// = $.extend({}, mEnrolleesData.SchedulesZonesClean);
            uCarveOutScheduleButton_OnClick(lCard.Id);
        }
       
    }
}